import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonLibraryVariableSetOverview } from "../../CommonComponents/CommonLibraryVariableSetViews";
export const LibraryVariableSetRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.library.variableSet,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryVariableSetOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
